import { mutator } from 'satcheljs';
import getStore from '../store/store';
import setIsSaving from '../actions/setIsSaving';

/**
 * Updates the current settings saving status in the store.
 */
export default mutator(setIsSaving, actionMessage => {
    let store = getStore();
    store.isSaving = actionMessage.isSaving;
});
